import { Component } from '@nicolas-riciotti/light2';
import { isMobilePortrait } from '../../helpers/isMobile';
import getPosition from '../../helpers/getPosition';

export default class BlockEnterprise extends Component {

    created() {
        this.time = 0;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
    }

    resize() {
        this._width  = this.clientWidth;
        this._height = this.clientHeight;

        if (this.$svg) {
            this.$svg.setAttribute('width', this._width);
            this.$svg.setAttribute('height', this._height);
            this.$svg.setAttribute('viewBox', `0 0 ${this._width} ${this._height}`);
        }

        if (this.$mask) {
            this.$mask.setAttribute('width', this._width);
            this.$mask.setAttribute('height', this._height);
        }

        if (this.$maskBg) {
            this.$maskBg.setAttribute('width', this._width);
            this.$maskBg.setAttribute('height', this._height);
        }

        this.$slides.forEach((el) => {
            el._width  = el.clientWidth;
            el._height = el.clientHeight;
        });
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    detached() {
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
    }

    attached() {
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.style.position = 'relative';

        this.$slides = this.querySelectorAll('[data-slide]');

        this.$slides.forEach((el) => {
            el.style.position = 'absolute';
            el.style.top = 0;
            el.style.left = 0;
            el.style.transformOrigin = '50% 50%';
        });

        // SVG lines layer
        this.$svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.$svg.style.position = 'absolute';
        this.$svg.style.top = 0;
        this.$svg.style.left = 0;
        this.$svg.style.width = '100%';
        this.$svg.style.height = '100%';
        this.$svg.style.pointerEvents = 'none';
        this.$svg.style.zIndex = 0;
        this.$svg.style.overflow = 'visible';

        this.$lines = [];
        this.$maskRects = [];

        this.$defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        this.$mask = document.createElementNS('http://www.w3.org/2000/svg', 'mask');

        const maskId = `block-enterprise-mask-${Math.round(Math.random() * 1000000)}`;

        this.$mask.setAttribute('id', maskId);
        this.$mask.setAttribute('maskUnits', 'userSpaceOnUse');
        this.$mask.setAttribute('x', '0');
        this.$mask.setAttribute('y', '0');
        this.$mask.setAttribute('width', '100%');
        this.$mask.setAttribute('height', '100%');

        // White = visible
        this.$maskBg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        this.$maskBg.setAttribute('x', '0');
        this.$maskBg.setAttribute('y', '0');
        this.$maskBg.setAttribute('width', '100%');
        this.$maskBg.setAttribute('height', '100%');
        this.$maskBg.setAttribute('fill', 'white');

        this.$mask.appendChild(this.$maskBg);
        this.$defs.appendChild(this.$mask);
        this.$svg.appendChild(this.$defs);

        this.$linesGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.$linesGroup.setAttribute('mask', `url(#${maskId})`);

        this.$svg.appendChild(this.$linesGroup);

        this.$slides.forEach(() => {
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');

            line.setAttribute('stroke', 'currentColor');
            line.setAttribute('stroke-width', '1');
            line.setAttribute('stroke-linecap', 'round');
            line.setAttribute('vector-effect', 'non-scaling-stroke');

            // Black = hidden hole in the mask
            const maskRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

            maskRect.setAttribute('fill', 'black');
            maskRect.setAttribute('rx', '6');
            maskRect.setAttribute('ry', '6');

            this.$linesGroup.appendChild(line);
            this.$mask.appendChild(maskRect);

            this.$lines.push(line);
            this.$maskRects.push(maskRect);
        });



        this.prepend(this.$svg);

        this.resize();

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                this.resize();

                requestAnimationFrame(() => {
                    this.resize();
                });
            });
        }


    }

    update() {
        
        // if (window.innerWidth < 600) {
        //     return;
        // }

        if (!this.stopped) {
            this.time += 0.01;
        }

        const angleStep = (Math.PI * 2) / this.$slides.length;

        let maxW = 0;
        let maxH = 0;
        this.$slides.forEach((el) => {
            maxW = Math.max(el._width, maxW);
            maxH = Math.max(el._height, maxH);
        });

        // const radius = Math.min(
        //     this._width / 2 - maxW / 2,
        //     this._height / 2 - maxH / 2
        // );
        const radiusY = Math.min(
            this._width / 2 - maxW / 2,
            this._height / 2 - maxH / 2
        );
        const radiusX = radiusY;

        const centerX = this._width / 2;
        const centerY = this._height / 2;

        // Fake 3D disk rotation
        const rotX = Math.sin(this.time * 0.7) * 0.9;
        const rotY = Math.cos(this.time * 0.5) * 0.9;
        const rotZ = this.time * 0.8;

        this.$slides.forEach((el, i) => {
            const a = i * angleStep;

            // Point on a flat disk before rotation
            let x = Math.cos(a) * radiusX;
            let y = Math.sin(a) * radiusY;
            let z = 0;

            // Rotate disk around Z
            const cosZ = Math.cos(rotZ);
            const sinZ = Math.sin(rotZ);

            const x1 = x * cosZ - y * sinZ;
            const y1 = x * sinZ + y * cosZ;
            const z1 = z;

            // Rotate disk around X
            const cosX = Math.cos(rotX);
            const sinX = Math.sin(rotX);

            const x2 = x1;
            const y2 = y1 * cosX - z1 * sinX;
            const z2 = y1 * sinX + z1 * cosX;

        // Rotate disk around Y
const cosY = Math.cos(rotY);
const sinY = Math.sin(rotY);

const x3Raw = x2 * cosY + z2 * sinY;
const y3 = y2;
const z3 = -x2 * sinY + z2 * cosY;

// Fake depth
const depth = (z3 / radiusY + 1) / 2;

// Fake wide perspective, horizontal only
const widePerspective = 1.15 + depth * 0.45;

const x3 = x3Raw * widePerspective;

const scale = 0.7 + depth * 0.55;
const opacity = 0.6 + depth * 0.4;

const nodeX = centerX + x3;
const nodeY = centerY + y3;

            const finalX = nodeX - el._width / 2;
            const finalY = nodeY - el._height / 2;

            el.style.transform = `
                translate(${finalX}px, ${finalY}px)
                scale(${scale})
                translateZ(0)
            `;

            // el.style.filter = `blur(${blur}px)`;
            el.style.opacity = opacity;
            el.style.zIndex = Math.round(depth * 1000) + 2;




const line = this.$lines[i];
const maskRect = this.$maskRects[i];

if (line && maskRect) {
    const centerMargin = window.innerWidth < 600 ? 60 : 80;
    const maskPaddingX = window.innerWidth < 600 ? 4 : 10;
    const maskPaddingY = window.innerWidth < 600 ? 4 : 6;

    const dx = nodeX - centerX;
    const dy = nodeY - centerY;
    const dist = Math.sqrt(dx * dx + dy * dy) || 1;

    const dirX = dx / dist;
    const dirY = dy / dist;

    const startX = centerX + dirX * centerMargin;
    const startY = centerY + dirY * centerMargin;

    // Keep the line perfectly stable:
    // center area -> node center
    line.setAttribute('x1', startX);
    line.setAttribute('y1', startY);
    line.setAttribute('x2', nodeX);
    line.setAttribute('y2', nodeY);
    line.setAttribute('opacity', 0.15 + depth * 0.45);

    // Cut a real hole in the line mask where the text is
    const maskW = el._width * scale + maskPaddingX * 2;
    const maskH = el._height * scale + maskPaddingY * 2;

    maskRect.setAttribute('x', nodeX - maskW / 2);
    maskRect.setAttribute('y', nodeY - maskH / 2);
    maskRect.setAttribute('width', maskW);
    maskRect.setAttribute('height', maskH);

    // Important:
    // black hides, white shows.
    // Keep this fully black, do not use opacity based on depth.
    maskRect.setAttribute('opacity', '1');
}            


        });
    }
}

customElements.define('block-enterprise', BlockEnterprise);